import { render, staticRenderFns } from "./QuoteItemSelector.vue?vue&type=template&id=45611c1f&"
import script from "./QuoteItemSelector.vue?vue&type=script&lang=js&"
export * from "./QuoteItemSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports